import "./Connect.module.css";
import Navigation from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Navigation />
      <Contact />
      <Faq />
      <Footer />
    </div>;
}